import app, { Component } from 'apprun';

import { isValidElement, showSaveStatusMessage, isStringEqual, lookup_en } from '../utils';
import { smartLead } from '../api';
import moment from 'moment';
export default class CommonPropertyComponent extends Component {
  dateFmt = 'DD-MMM-YYYY';

  state = { smartleads: [] };

  cleanState = {
    smartLeadStartDatePicker: null,
    smartLeadEndDatePicker: null,
    editingItem: null,
    newSmartLead: null,
    smartLeadSaveError: null,
    smartLeadFee: []
  };

  Item = ({ item, startDate }) => {
    return (
      <tr
        style={{ display: 'table-row' }}
        onclick={
          (e) => {
            this.run('smartLead-edit', item, e);
          }
        }>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {this.getSmartLeadName(item.smartLeadFeeID)}
          </span>
        </td>
        <td>
          <div class="col-sm-2 text-right">
            {moment.utc(item.startDate).format(this.dateFmt) === startDate ? <i class="control-label glyphicon glyphicon-pencil" /> : ''}
          </div>
        </td>
      </tr>
    );
  };

  List = ({ state }) => {
    return (
      <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
        <thead>
          <tr>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Fee Option</th>
          </tr>
        </thead>
        <tbody>
          {state.smartleads.map(item => (
            <this.Item item={item} startDate={state.startDate} />
          ))}
        </tbody>
      </table>
    );
  };

  SmartLeadHistory = ({ state }) => {
    return (
      <div>
        {/* <div class="col-sm-12">SmartLead History</div> */}
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.List state={state} />
        </div>
      </div>
    );
  };

  SmartLeadEdit = ({ state }) => {
    return (
      <div style={{ display: state.editingProg ? 'disp' : 'none' }}>
        <div class="row" style={{ display: state.newSmartLead ? 'disp' : 'none' }}>
          **NEW**
        </div>
        <div class="row">
          <label class="col-sm-5">Start Date</label>
          <label class="col-sm-5">End Date</label>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="smartLeadStartDate" size="62" class="form-control" value={state.smartLeadStartDate} />
          </div>
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="smartLeadEndDate" size="62" class="form-control" value={state.smartLeadEndDate} />
          </div>
        </div>
        <div class="row">
          <div id="smartLeadStartDateErrMsg" class="text-danger, col-sm-5"></div>
          <div id="smartLeadEndDateErrMsg" class="text-danger, col-sm-5"></div>
          <div id="smartLeadReturnedErrMsg" class="text-danger, col-sm-5">
            {state.smartLeadSaveError}
          </div>
        </div>
        <br></br>
        <div class="row">
          <label class="col-sm-5">Fee Option</label>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <this.ddlComp
              id="smartLeadFeeID"
              optoins={lookup_en['SmartLeadOption']}
              objWithRetAttrib={state.progUnderEdit}
              retAttrib="smartLeadFeeID"
            />
          </div>
        </div>

        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('smartLead-edit-save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('smartLead-edit-cancel')}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  ddlComp = ({ id, optoins, objWithRetAttrib, retAttrib }) => {
    return (
      <div>
        <select id={id} class="form-control" oninput={e => (objWithRetAttrib[retAttrib] = e.target.value)}>
          <option value="0">[Select]</option>
          {optoins.map(p => (
            <option
              value={p.id}
              selected={isStringEqual(p.id, objWithRetAttrib?.[retAttrib])?'selected':''}>
              {p.value}
            </option>
          ))}
        </select>
        <div id={id + 'ErrMsg'} class="text-danger, row"></div>
      </div>
    );
  };

  // prettier-ignore
  view = (state) => {
    return (
      <div style={{ width: '550px' }}>
        <this.SmartLeadHistory state={state} />
        <div>
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('smartLead-new', e)}>
            Add New SmartLead
          </a>
        </div>
        <br/>
        <this.SmartLeadEdit state={state} />
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      this.cleanState.smartLeadFee = lookup_en['SmartLeadOption'];
      if (newState.companyId !== state.companyId) {
        state = this.cleanState;
        state.companyId = newState.companyId;
      }
      state.smartleads = await smartLead.get(state.companyId);
      return { ...state, ...newState };
    },

    'smartLead-new': (state, e) => {
      this.run('smartLead-edit', { startDate: '', smartLeadFeeID: -1 }, e);
    },

    'smartLead-edit': (state, item) => {
      if (state.editingProg) {return;}

      state.smartLeadStartDate = item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : '';
      state.smartLeadEndDate = item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : '';

      state.startDate = state.smartLeadStartDate;
      state.smartLeadFeeID = item.smartLeadFeeID;
      state.companyID = item.companyID ;

      state.newSmartLead = state.startDate === '';
      state.editingProg = true;
      state.progUnderEdit = item;
      return state;
    },

    'smartLead-edit-save': async (state) => {
      state.smartLeadSaveError = null;
      const smartLeadReturnedErrMsgDiv = document.getElementById('smartLeadReturnedErrMsg') as HTMLDivElement;
      smartLeadReturnedErrMsgDiv.innerHTML = state.smartLeadSaveError;

      state.smartLeadStartDate = (document.getElementById('smartLeadStartDate') as HTMLInputElement).value.trim();
      state.smartLeadEndDate = (document.getElementById('smartLeadEndDate') as HTMLInputElement).value.trim();

      state.smartLeadFeeID = (document.getElementById('smartLeadFeeID') as HTMLInputElement).value.trim();

      let valid = isValidElement('smartLeadStartDate', 'DateStr');

      if(state.smartLeadStartDate){
        if (valid && moment(state.smartLeadStartDate, this.dateFmt).startOf('month').format('DD-MMM-YYYY') !== moment(state.smartLeadStartDate, this.dateFmt).format('DD-MMM-YYYY')){
          valid = false;
          const errMsg = document.getElementById('smartLeadStartDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = 'Start date must be the first day of month';
        }
      }

      if(state.smartLeadEndDate){
        valid = valid && isValidElement('smartLeadEndDate', 'DateStr');

        if (valid && moment(state.smartLeadEndDate, this.dateFmt).endOf('month').format('DD-MMM-YYYY') !== moment(state.smartLeadEndDate, this.dateFmt).format('DD-MMM-YYYY')){
          valid = false;
          const errMsg = document.getElementById('smartLeadEndDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = 'End date must be the end day of month';
        }

        if (valid && moment(state.smartLeadStartDate, this.dateFmt) > moment(state.smartLeadEndDate, this.dateFmt)) {
          valid = false;
          const errMsg = document.getElementById('smartLeadEndDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = 'End date cannot be before Start date';
        }

      }

      if (state.smartLeadFeeID === '0') {
        valid = false;
        const errMsg = document.getElementById('smartLeadFeeIDErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'Please fee option';
      }

      if (valid) {
        const smartleadToSave =
          state.startDate === ''
            ? { originalStartDate: state.startDate?state.startDate:'', companyId: state.companyId, smartLeadFeeID: state.smartLeadFeeID, startDate: state.smartLeadStartDate, endDate: state.smartLeadEndDate }
            : { ...state.progUnderEdit, originalStartDate: state.startDate, smartLeadFeeID: state.smartLeadFeeID, startDate: state.smartLeadStartDate, endDate: state.smartLeadEndDate };
        let result;
        try {
          result = await smartLead.upsertSmartLead(smartleadToSave);
          showSaveStatusMessage(result);
        } catch (ex) {
          showSaveStatusMessage();
          const errorMsg = await ex.json();
          state.smartLeadSaveError = '* ' + errorMsg;
          return state;
        }

        if (result) {
          state.smartleads = await smartLead.get(state.companyId);
          this.run('smartLead-edit-cancel');
        }
      }
    },

    'smartLead-edit-cancel': (state) => {
      state.editingProg = false;
      state.progUnderEdit = null;
      state.startDate = '';
      state.smartLeadSaveError = null;
      return state;
    }
  };

  getSmartLeadName = (id) => {
    const selected =  lookup_en['SmartLeadOption'].find(p => p.id === id);
    return selected.value;
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
